export default __webpack_public_path__ + "static/media/timer.890d9bc1.svg";